import { Countries } from './countries';

export class AppSettings {


	// public static API_ENDPOINT = 'http://localhost:3009/api/';

	// public static API_ENDPOINT = 'http://18.139.177.120:3009/api/';

    public static API_ENDPOINT = 'https://foodapp-clone.herokuapp.com/api/';

	 public static API_TIMEOUT = 3000; // 1 second Timeout  

	 public static LOGIN_ERROR = 'Either username/password invalid. Please try again.';
	 
	 public static LOGOUT_SUCCESS = 'Successfully Logout.';

	 public static SITE_NAME = 'FOODAPP';
	 
	 public static GENERIC_ERROR = 'There is some error. Please try again.';

	 public static DEFAULT_COURSE = "5c4645c20a3168054e04f915";

	 public static BUCKETPATH = {
	   SERVICEBANNERIMAGE:"SERVICEBANNERIMAGE",
	   RESTAURANTIMAGES:'Restaurant Images',
	   DISHES:'DISHES'
    }

	 public static ROLE = {
	 	SUPERADMIN : "5dcbeb4a5a797d2b33e5a806",
	 	ADMIN : "5da08108ed85362b06e367b9",
	 	SUBADMIN : "5dcbebdc5a797d2b33e5a808",
		FRONTEND : "5d8622664c46c43ce789ea3f",
		VENDOR :'5dcbeb5d5a797d2b33e5a807'
	 }

	 public static COUNTRIES_LIST = Countries.ALL_COUNTRIES;

	 public static MESSAGE = {
	 	USER : {
	 		ADD_TITLE : "Registerd Successfully",
	 		ADD : "Congratulations you have created an account. A confirmation email has been sent. To activate the FoodApp, simply click on the word Verify in the email you received. Be sure to check your Clutter and Junk Email folders.",
	 		EDIT : "User Info has been updated",
	 		DELETE : "User has been deleted",
	 		DELETE_CONFIRM : "Are you sure you want to delete this user?",
	 		SIGNUP_ERR : "Email address already exist. Please try again.",
	 		FORGET_PASSWORD : "Reset Password link has been sent at your email address.",
	 		RESET_PASSWORD	: "Congratulations! Your password has been reset successfully.",
	 		CHANGE_PASSWORD	: "Congratulations! Your password has been changed successfully.",

	 	},
	 
	 	LOGIN : {
	 		VERFY_ACCESS_CODE_ERR : "Access Code is invalid. Please try again."
		 }
	 }

	 public static FIELDS = {
	 	
	 }

	 public static CSV_NAME = {
		 FRONTEND_USER_LIST : 'FoodApp Frontend Customers',
		 SUBADMIN_LIST : 'FoodApp Subadmin users',
		 COUPONS:'Coupons'
	 }


	 public static URLS = {
	 	ADMIN : {
	 		DASHBOARD : '/admin/dashboard',
	 		USERS : '/admin/users',
			SUBADMIN : '/admin/sub-admin',
			RESTAURANT:'/admin/restaurant',
			MENU:'/admin/menu',
			DISHES:'/admin/dishes',
			RIDERS:'/admin/riders',

			COUPONS:'/admin/coupon',
			OFFER:'/admin/offer',
			OFFERRESTAURANT:'/admin/offerRestaurant',
			ORDER:'/admin/order',
			VENDOR:'/admin/vendor',
			QUERY:"/Query"

	 	}
	 }

	 public static SITE_TITLE_PREFIX = AppSettings.SITE_NAME + ' - ';


	public static ADMIN_METADATA = {
		USER_LIST :	{
		  title: AppSettings.SITE_TITLE_PREFIX + 'Frontend Users',
		  urls: [
		    { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
		    { title: 'Users' }
		  ]
		},
		ADD_USER :	{
		  title: AppSettings.SITE_TITLE_PREFIX + 'Invite User',
		  urls: [
		    { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
		    { title: 'Users' , url : AppSettings.URLS.ADMIN.USERS },
		    { title : 'Invite User'}
		  ]
		},
		EDIT_USER :	{
		  title: AppSettings.SITE_TITLE_PREFIX + 'Edit Frontend User',
		  urls: [
		    { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
		    { title: 'Users' , url : AppSettings.URLS.ADMIN.USERS },
		    { title : 'Edit User'}
		  ]
		},
		

		VENDOR_LIST :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Vendor Listing',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Vendor' }
			]
		  },
		  ADD_VENDOR :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Add Vendor',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Vendor' , url : AppSettings.URLS.ADMIN.SUBADMIN },
			  { title : 'Add Vendor'}
			]
		  },
		  EDIT_VENDOR :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Edit Vendor',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Vendor' , url : AppSettings.URLS.ADMIN.SUBADMIN },
			  { title : 'Edit Vendor'}
			]
		  },


		SUBADMIN_LIST :	{
		  title: AppSettings.SITE_TITLE_PREFIX + 'Sub Admin Listing',
		  urls: [
		    { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
		    { title: 'Sub Admin' }
		  ]
		},
		ADD_SUBADMIN :	{
		  title: AppSettings.SITE_TITLE_PREFIX + 'Add Sub Admin',
		  urls: [
		    { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
		    { title: 'Sub Admin' , url : AppSettings.URLS.ADMIN.SUBADMIN },
		    { title : 'Add Sub Admin'}
		  ]
		},
		EDIT_SUBADMIN :	{
		  title: AppSettings.SITE_TITLE_PREFIX + 'Edit Sub Admin',
		  urls: [
		    { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
		    { title: 'Sub Admin' , url : AppSettings.URLS.ADMIN.SUBADMIN },
		    { title : 'Edit Sub Admin'}
		  ]
		},

		ORDER_LIST :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Order Listing',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Order' }
			]
		  },
		  EDIT_ORDER :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Edit Order',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Order' , url : AppSettings.URLS.ADMIN.ORDER },
			  { title : 'Edit Order'}
			]
		  },




		RESTAURANT_LIST :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Restaurant Listing',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Restaurant' }
			]
		  },
		  ADD_RESTAURANT :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Add Restaurant',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Restaurant' , url : AppSettings.URLS.ADMIN.RESTAURANT },
			  { title : 'Add Restaurant'}
			]
		  },
		  EDIT_RESTAURANT :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Edit Restaurant',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Restaurant' , url : AppSettings.URLS.ADMIN.RESTAURANT },
			  { title : 'Edit Restaurant'}
			]
		  },
		  QUERY_LISTING: {
			title: AppSettings.SITE_TITLE_PREFIX + "Query Listing",
			urls: [
			  { title: "Dashoard", url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: "Query", url: AppSettings.URLS.ADMIN.QUERY },
			],
		  },
		  QUERY_DETAIL: {
			title: AppSettings.SITE_TITLE_PREFIX + "Query Detail",
			urls: [
			  { title: "Dashoard", url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: "Query", url: AppSettings.URLS.ADMIN.QUERY },
			  { title: "Query Details" },
			],
		  },

		  	MENU_LIST :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Menu Listing',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Menu' }
			]
		  },
		  ADD_MENU :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Add Menu',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Menu' , url : AppSettings.URLS.ADMIN.MENU },
			  { title : 'Add Menu'}
			]
		  },
		  EDIT_MENU :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Edit Menu',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Menu' , url : AppSettings.URLS.ADMIN.MENU },
			  { title : 'Edit Menu'}
			]
		  },
		DISHES_LIST :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Dishes Listing',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Dishes' }
			]
		  },
		  ADD_DISHES :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Add Dishes',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Dishes' , url : AppSettings.URLS.ADMIN.DISHES },
			  { title : 'Add Dishes'}
			]
		  },
		  EDIT_DISHES :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Edit Dishes',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Dishes' , url : AppSettings.URLS.ADMIN.DISHES },
			  { title : 'Edit Dishes'}
			]
		  },



		  RIDERS_LIST :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Riders Listing',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Riders' }
			]
		  },
		  ADD_RIDER :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Add Riders',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Riders' , url : AppSettings.URLS.ADMIN.RIDERS },
			  { title : 'Add Riders'}
			]
		  },
		  EDIT_RIDER :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Edit Riders',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Riders' , url : AppSettings.URLS.ADMIN.RIDERS },
			  { title : 'Edit Riders'}
			]
		  },



		  COUPON_LIST :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Coupon Listing',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Coupon' }
			]
		  },
		  ADD_COUPON :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Add Coupon',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Coupon' , url : AppSettings.URLS.ADMIN.COUPONS },
			  { title : 'Add Coupon'}
			]
		  },
		  EDIT_COUPON :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Edit Coupon',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Coupon' , url : AppSettings.URLS.ADMIN.COUPONS },
			  { title : 'Edit Coupon'}
			]
		  },
		  OFFER_LIST :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Offer Listing',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Offer' }
			]
		  },
		  ADD_OFFER :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Add Offer',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Offer' , url : AppSettings.URLS.ADMIN.OFFER },
			  { title : 'Add Offer'}
			]
		  },
		  EDIT_OFFER :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Edit Offer',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Offer' , url : AppSettings.URLS.ADMIN.OFFER },
			  { title : 'Edit Offer'}
			]
		  },
		  OFFERRESTAURANT_LIST :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Offer Restaurant Listing',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Offer Restaurant' }
			]
		  },
		  ADD_OFFERRESTAURANT :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Add Offer Restaurant',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Offer Restaurant' , url : AppSettings.URLS.ADMIN.OFFERRESTAURANT },
			  { title : 'Add Offer Restaurant'}
			]
		  },
		  EDIT_OFFERRESTAURANT :	{
			title: AppSettings.SITE_TITLE_PREFIX + 'Edit Offer Restaurant',
			urls: [
			  { title: 'Dashoard', url: AppSettings.URLS.ADMIN.DASHBOARD },
			  { title: 'Offer Restaurant' , url : AppSettings.URLS.ADMIN.OFFERRESTAURANT },
			  { title : 'Edit Offer Restaurant'}
			]
		  },

	}
}